import { Component } from '@angular/core';

@Component({
  selector: 'rota-preload-resources',
  templateUrl: `preload-resources.html`,
  styleUrl: 'preload-resources.scss',
  standalone: false,
})
export class RotaPreloadReourcesComponent {}
